module.exports = __webpack_public_path__ + "media/tips.097c3dbf.mp3";